export default __webpack_public_path__ + "static/media/characters-5.cb93099d.png";